/**
 * Utility functions for API handling
 */

import { isTraderHost } from '@/utils/tenant-detection';

/**
 * Determines the correct API base URL based on the current subdomain
 * @returns The API base URL
 */
export const getApiBaseUrl = (): string => {
    const host = window.location.host;

    // Check if we're on the trader subdomain (trader. or trade.)
    if (isTraderHost(host)) {
        return '/api/v1/trader';
    }

    // Check if we're on the CRM subdomain
    if (host.includes('crm.')) {
        return '/api/v1/crm';
    }

    // Default to CRM for localhost or other domains
    return '/api/v1/crm';
};

/**
 * Gets the impersonation endpoints based on the current subdomain
 */
export const getImpersonationEndpoints = () => {
    const host = window.location.host;

    if (isTraderHost(host)) {
        return {
            status: '/trader/impersonation/status',
            stop: '/trader/impersonation/stop',
        };
    }

    // CRM endpoints
    return {
        status: '/crm/impersonation/status',
        start: '/crm/impersonation/start',
        stop: '/crm/impersonation/stop',
        listCustomers: '/crm/impersonation/customers',
        clearSession: '/crm/impersonation/clear-session',
    };
};
